<template>
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Heart">
<path id="Shape" d="M5.39554 1.02423C6.58835 1.02423 7.67642 1.64172 8.50038 2.3452C9.32433 1.64172 10.4124 1.02423 11.6052 1.02423C14.1774 1.02423 16.2625 3.01338 16.2625 5.46698C16.2625 10.4141 10.8484 13.2953 9.06353 14.1107C8.70402 14.275 8.29674 14.275 7.93723 14.1107C6.1524 13.2953 0.738281 10.414 0.738281 5.46686C0.738281 3.01327 2.82341 1.02423 5.39554 1.02423Z" stroke="white"/>
</g>
</svg>

</template>